<template>
  <div>
    <div class="hi1">
      <div class="hi1-content">
        <h1 class="title">{{ ourHistory.titleOne }}</h1>
        <p v-html="$convertPxToRem(ourHistory.contentOne)"></p>

        <!-- Swiper -->
        <div class="styles_swiper" v-if="imageCollection.length > 0">
          <div class="swiper-container image-collection">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <custom-video :url="imageCollection[0].files" ></custom-video>
              </div>
              <div class="swiper-slide" v-for="(img, i) in imageCollection[0].full_images.split(',')" :key="i">
                <el-image :src="img" fit="cover"></el-image>
              </div>
            </div>
            <!-- 导航按钮 -->
            <div class="swiper-button-next swiper-button-white"></div>
            <div class="swiper-button-prev swiper-button-white"></div>
          </div>
          <div class="swiper-container gallery-thumbs">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <custom-video :url="imageCollection[0].files" :disable="true"></custom-video>
              </div>
              <div class="swiper-slide" v-for="(img, i) in imageCollection[0].full_images.split(',')" :key="i">
                <el-image :src="img" fit="cover"></el-image>
              </div>
            </div>
          </div>
        </div>
        <!-- <img
          src="../../assets/images/about/history1.jpg"
          alt=""
          style="margin-top: 70px"
        /> -->
      </div>
    </div>
    <div class="hi2">
      <template v-for="(item, index) in articleList">
        <template v-if="index % 2 === 0">
          <div class="history_left">
          <div class="history_year">
            {{ item[`${currentLang.prefix}title`] }}
            <div class="sanjiao_left"></div>
            <div class="yuandian_left"></div>
          </div>
          <div class="history_details">
            <ul>
              <li v-html="$convertPxToRem(removeHtmlStyle(item[`${currentLang.prefix}content`]))"></li>
            </ul>
          </div>
        </div>
        </template>
        <template v-if="index % 2 === 1">
          <div class="history_right">
        <div class="history_year">
          {{ item[`${currentLang.prefix}title`] }}
          <div class="sanjiao_right">
          </div>
          <div class="yuandian_right"></div>
        </div>
        <div class="history_details">
          <ul>
            <li v-html="$convertPxToRem(removeHtmlStyle(item[`${currentLang.prefix}content`]))"></li>
          </ul>
        </div>
      </div>
        </template>
      </template>
      <!-- 
      
      <div class="history_left">
        <div class="history_year">
          {{ ourHistory.list[2].year }}
          <div class="sanjiao_left">
          </div>
          <div class="yuandian_left"></div>
        </div>
        <div class="history_details">
          <ul>
            <li>{{ ourHistory.list[2].content }}</li>
          </ul>
        </div>
      </div>
      <div class="history_right">
        <div class="history_year">
          {{ ourHistory.list[3].year }}
          <div class="sanjiao_right">
          </div>
          <div class="yuandian_right"></div>
        </div>
        <div class="history_details">
          <ul>
            <li>{{ ourHistory.list[3].content }}</li>
          </ul>
        </div>
      </div>
      <div class="history_left">
        <div class="history_year">
          {{ ourHistory.list[4].year }}
          <div class="sanjiao_left">
          </div>
          <div class="yuandian_left"></div>
        </div>
        <div class="history_details">
          <ul>
            <li>{{ ourHistory.list[4].content }}</li>
          </ul>
        </div>
      </div>
      <div class="history_right">
        <div class="history_year">
          {{ ourHistory.list[5].year }}
          <div class="sanjiao_right">                                               
          </div>
          <div class="yuandian_right"></div>
        </div>
        <div class="history_details">
          <ul>
            <li v-html="ourHistory.list[5].content"></li>
          </ul>
        </div>
      </div>
      <div class="history_left">
        <div class="history_year">
          {{ ourHistory.list[6].year }}
          <div class="sanjiao_left"></div>
          <div class="yuandian_left"></div>
        </div>
        <div class="history_details">
          <ul>
            <li>{{ ourHistory.list[6].content }}</li>
          </ul>
        </div>
      </div>
      <div class="history_right">
        <div class="history_year">
          {{ ourHistory.list[7].year }}
          <div class="sanjiao_right">
          </div>
          <div class="yuandian_right"></div>
        </div>
        <div class="history_details">
          <ul>
            <li v-html="ourHistory.list[7].content"></li>
          </ul>
        </div>
      </div>
      <div class="history_left">
        <div class="history_year">
          {{ ourHistory.list[8].year }}
          <div class="sanjiao_left"></div>
          <div class="yuandian_left"></div>
        </div>
        <div class="history_details">
          <ul>
            <li v-html="ourHistory.list[8].content"></li>
          </ul>
        </div>
      </div>
      <div class="history_right">
        <div class="history_year">
          {{ ourHistory.list[9].year }}
          <div class="sanjiao_right">
          </div>
          <div class="yuandian_right"></div>
        </div>
        <div class="history_details">
          <ul>
            <li>{{ ourHistory.list[9].content }}</li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { getArticleList } from "@/utils/http.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      articleList: [],
      imageCollection: []
    };
  },
  computed: {
    ...mapGetters(["currentLang"]),

    ourHistory() {
      return this.currentLang.config.aboutPage.ourHistory;
    }
  },
  mounted() {
    this.getArticle();
    this.getImageCollection();
  },
  methods: {
    // 图片集轮播墙初始化
    initSwiper() {
      const galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4,
        // loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      const imageCollectionSwiper = new Swiper('.image-collection', {
        spaceBetween: 10,
        // loop:true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    },

    getArticle() {
      getArticleList({
        cate_id: 92
      }).then(res => {
        // console.log("getArticleList", res);
        if (res.code === 1) {
          this.articleList = res.data.list;
        }
      });
    },

    getImageCollection() {
      getArticleList({
        cate_id: 94
      }).then(res => {
        if (res.code === 1) {
          this.imageCollection = res.data.list;
          this.$nextTick(() => {
            this.initSwiper()
          })
        }
      });
    },

    removeHtmlStyle(html) {
      let rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/g;
      let newHtml = "";
      if (html) {
        newHtml = html.replace(rel, "");
      }
      // 清除类名
      // let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;
      // let newClassHtml = "";
      // if (newHtml) {
      //   newClassHtml = newHtml.replace(relClass, "");
      // }
      return newHtml;
    }
  }
};
</script>

<style lang="scss" scoped>
.styles_swiper {
  width: 100%;
  height: auto;
  margin-top: 70px;

  .swiper-wrapper {
    width: 100%;
    transform: translate3d(0, 0px, 0px);
    transition-timing-function: linear;
    align-items: center;
  }

  .swiper-slide {
    display: flex;
    justify-items: center;
    width: 100%;
    overflow: hidden;
    // width: 380px;
    // height: 280px;
  }

  .swiper-slide img {
    width: auto;
    height: auto;
  }

  .swiper-slide-item {
    display: inline-block;
    box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.2);
  }

  .image-collection {
    background-color: rgba(0, 0, 0, 1);
  }

  .gallery-thumbs {
    box-sizing: border-box;
    padding: 4px 0;
    background-color: rgba(0, 0, 0, 1);
  }
  .gallery-thumbs .swiper-slide {
    width: 30%;
    height: 100%;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }

  /deep/ .el-image {
    width: 100%;
  }
}


.hi1 {
  width: 1000px;
  margin: 70px auto;
  text-align: center;
  .hi1-content {
    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
      margin-bottom: 30px;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      margin-top: 40px;
      line-height: 1.8;
      text-align: justify;
      text-align-last: center;
    }
  }
}


.hi2 {
  padding-bottom: 90px;
  width: 1200px;
  margin: 0 auto 0;
  //   当大事记数据在左侧时
  .history_left {
    width: calc(50% - 1px);
    border-right: 1px solid #bbb;
    .history_year {
      width: 560px;
      background: #003359;
      text-align: center;
      color: #fff;
      font-size: 24px;
      line-height: 60px;
      position: relative;
      .sanjiao_left {
        border-left: 14px solid #003359;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        position: absolute;
        right: -12px;
        top: 18px;
      }
      .yuandian_left {
        width: 16px;
        height: 16px;
        background: #003359;
        position: absolute;
        right: -48px;
        top: 20px;
        border-radius: 50%;
      }
    }
    .history_details {
      background: #f5f5f5;
      width: calc(100% - 100px);
      padding: 20px 30px 20px 30px;
      ul {
        color: #777;
        font-size: 16px;
        line-height: 32px;
        list-style: disc;
      }
    }
  }
  //   当大事记数据在右侧时
  .history_right {
    width: 50%;
    margin-left: 599px;
    border-left: 1px solid #bbb;
    padding-left: 39px;
    .history_year {
      width: 560px;
      background: #003359;
      text-align: center;
      color: #fff;
      font-size: 24px;
      line-height: 60px;
      position: relative;
      .sanjiao_right {
        border-right: 14px solid #003359;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        position: absolute;
        left: -12px;
        top: 18px;
      }
      .yuandian_right {
        width: 16px;
        height: 16px;
        background: #003359;
        position: absolute;
        left: -48px;
        top: 20px;
        border-radius: 50%;
      }
    }
    .history_details {
      background: #f5f5f5;
      width: calc(100% - 100px);
      padding: 20px 30px 20px 30px;
      ul {
        color: #777;
        font-size: 16px;
        list-style: disc;
        line-height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/history.vue